import { ActionTree, Commit } from "vuex";
import { RootState } from "../types";
import { UserState } from "./types";
import User from "../../models/User";

export const actions: ActionTree<UserState, RootState> = {
  async fetchCurrentUser(context: {
    commit: Commit;
    rootState: RootState;
  }): Promise<User> {
    const user = await context.rootState.apiClient.getCurrentUser();
    context.commit("setUser", user);
    return user;
  },

  async sendActivationEmail(context: { rootState: RootState }) {
    await context.rootState.apiClient.sendActivationEmail();
  },

  async setEmergency(
    context: { commit: Commit; rootState: RootState },
    payload: {
      emergency: number;
      emergencyPhoneNumber: string;
    }
  ): Promise<void> {
    const user = await context.rootState.apiClient.setEmergency(payload);
    context.commit("setUser", user);
  },

  async disableEmergency(context: {
    commit: Commit;
    rootState: RootState;
  }): Promise<void> {
    const user = await context.rootState.apiClient.setEmergency({
      emergency: 0,
      emergencyPhoneNumber: null
    });
    context.commit("setUser", user);
  }
};
